<template>
  <v-menu 
    v-model="show"
    :close-on-click="true"
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        :color="(!item||!item.audit_customer||!item.audit_customer.account) &&'primary'"
        v-bind="attrs"
        :loading="loading"
        v-on="on"
      >
        {{ item&&item.audit_customer&&item.audit_customer.account || '请选择' }}
      </v-btn>
    </template>
    <v-card>
      <div style="min-width:300px;margin:0 20px">
        <VCustomerSelector 
          @change="selectItem"
        />
      </div>
    </v-card>
  </v-menu>
</template>

<script>
  import VCustomerSelector from '@/views/components/customer/v-selector';
  export default {
    components: {VCustomerSelector},
    props: {
      item: {
        type: Object
      },
      loading: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {
        show: false,
        items: [
          {
            title: '测试'          
          }
        ]
      }
    },
    methods: {
      selectItem(data) {
        this.$emit('change', data, this.item)
        this.show = false
      }
    }
  }
</script>
